
<template>
    <v-select
              :items="availableCashiers"
              label="Selecione o(s) caixa(s)"
              density="compact"
              item-title="name"
              v-model="selectedItems"
              clearable
              multiple
              return-object>
        <template v-slot:no-data>
            <div class="px-4">Nenhum caixa encontrado para o grupo</div>
        </template>
    </v-select>
</template>
<script>
import api from '@/services'

export default {
    components: {},
    props: {
        user: Object,
        selectedGroup: Number,
        modelValue: Array,
    },
    emits: ["update:modelValue"],
    data() {
        return {
            requestingApi: false,
            group_id: this.selectedGroup || 777,
            lstObjects: [],
            selectedItems: []
        };
    },
    created() { },
    mounted() {
        this.listAll();
    },
    activated() { },
    methods: {
        listAll() {
            const vm = this;

            if (!vm.requestingApi) {
                vm.requestingApi = true;
                return new Promise((resolve, reject) => {
                    api.cashier
                        .list({ group_id: vm.group_id, itemsPerPage: 30 }, 1)
                        .then((result) => {
                            vm.lstObjects = [...vm.lstObjects, ...result?.data];
                            if (result?.total && result?.total > 30) {
                                vm.enableSearch = true
                            }
                        })
                        .catch((err) => {
                            //
                        })
                        .finally(() => {
                            vm.requestingApi = false;
                            vm.loading = false;
                        });
                });
            }
        },
    },
    computed: {
        availableCashiers() {
            const vm = this;

            return vm.lstObjects.filter(c => c.group_id === vm.group_id);
        }
    },
    watch: {
        selectedItems(newItems) {
            this.$emit("update:modelValue", newItems);
        },
        selectedGroup(newGroup) {
            const vm = this;

            vm.group_id = newGroup || 777;
            if (!vm.lstObjects.find(c => c.group_id === vm.group_id)) {
                vm.listAll();
            }
        }
    },
};
</script>
